// How the shipment physically leaves: on a freight Truck, or shipped Ground via a
// parcel carrier (UPS/FedEx). Tied to the shipment (not the carrier) because the
// warehouse's pickup times differ by method, so they filter their queue by it.
export enum PlasticsShipmentShippingMethod {
    Truck = 'truck',
    Ground = 'ground',
}
